import { render, staticRenderFns } from "./SearchSubstanceInList.vue?vue&type=template&id=17cd85a1&"
import script from "./SearchSubstanceInList.vue?vue&type=script&lang=js&"
export * from "./SearchSubstanceInList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports